import {
  dummyAudio,
  spaceListImg1,
  spaceListImg2,
  spaceListImg3,
  spaceListImg4,
  spaceListImg5,
  spaceListImg6,
} from "./Images";

export const Colors = {
  primary: "#ff5349",
};

export const AUTH_TOKEN_TEXT = "SpaciiAuthToken";
export const MENU_STATE_TEXT = "SpaciiSideMenuState";
export const THEME_STATE_TEXT = "SpaciiThemeModeState";

export const defaultMapCenter = {
  lat: 38.916615245276844,
  lng: -77.02626109558906,
};

export const defaultAvailability = [
  {
    label: "Sunday",
    day: "Sun",
    hours: [],
  },
  {
    label: "Monday",
    day: "Mon",
    hours: [],
  },
  {
    label: "Tuesday",
    day: "Tue",
    hours: [],
  },
  {
    label: "Wednesday",
    day: "Wed",
    hours: [],
  },
  {
    label: "Thursday",
    day: "Thu",
    hours: [],
  },
  {
    label: "Friday",
    day: "Fri",
    hours: [],
  },
  {
    label: "Saturday",
    day: "Sat",
    hours: [],
  },
];

export const messagesList = [
  {
    id: 1,
    type: "audio",
    file: dummyAudio,
    isSupport: false,
    time: "2:21",
    reaction: "",
  },
  {
    id: 2,
    type: "audio",
    file: dummyAudio,
    isSupport: false,
    time: "2:21",
    reaction: "",
  },
  {
    id: 3,
    type: "text",
    message: "Need you help, can you please tell me the details.",
    isSupport: false,
    time: "2:21",
    reaction: "",
  },
  {
    id: 4,
    type: "audio",
    file: dummyAudio,
    isSupport: true,
    time: "2:21",
    reaction: "",
  },
  {
    id: 5,
    type: "text",
    message: "Need you help, can you please tell me the details.",
    isSupport: false,
    time: "2:21",
    reaction: "",
  },
  {
    id: 6,
    type: "audio",
    file: dummyAudio,
    isSupport: true,
    time: "2:21",
    reaction: "",
  },
];

export const popularSpaceVanue = [
  {
    id: 1,
    images: [
      spaceListImg1,
      spaceListImg2,
      spaceListImg3,
      spaceListImg4,
      spaceListImg5,
      spaceListImg6,
    ],
    title: "Figleaf Bar & Lounge",
    description: "An inviting space that combines perfect for birthday...",
    persons: 50,
    ratting: 4.8,
    reviews: 120,
    price: 1199,
  },
  {
    id: 2,
    images: [
      spaceListImg6,
      spaceListImg1,
      spaceListImg2,
      spaceListImg3,
      spaceListImg4,
      spaceListImg5,
    ],
    title: "Figleaf Bar & Lounge",
    description: "An inviting space that combines perfect for birthday...",
    persons: 50,
    ratting: 4.8,
    reviews: 120,
    price: 1199,
  },
  {
    id: 3,
    images: [
      spaceListImg5,
      spaceListImg6,
      spaceListImg1,
      spaceListImg2,
      spaceListImg3,
      spaceListImg4,
    ],
    title: "Figleaf Bar & Lounge",
    description: "An inviting space that combines perfect for birthday...",
    persons: 50,
    ratting: 4.8,
    reviews: 120,
    price: 1199,
  },
  {
    id: 4,
    images: [
      spaceListImg4,
      spaceListImg5,
      spaceListImg6,
      spaceListImg1,
      spaceListImg2,
      spaceListImg3,
    ],
    title: "Figleaf Bar & Lounge",
    description: "An inviting space that combines perfect for birthday...",
    persons: 50,
    ratting: 4.8,
    reviews: 120,
    price: 1199,
  },
];

export const adminPropertyList = [
  {
    id: 1,
    name: "Lux Dc Bar & Lounge",
    spaces: "01",
    location: "United State",
    size: "1250 sqft",
  },
  {
    id: 2,
    name: "The DC DeckHouse",
    spaces: "02",
    location: "United State",
    size: "1250 sqft",
  },
  {
    id: 3,
    name: "Speakeasy Experience",
    spaces: "02",
    location: "United State",
    size: "1250 sqft",
  },
  {
    id: 4,
    name: "District Heights Flex Space",
    spaces: "03",
    location: "United State",
    size: "1250 sqft",
  },
  {
    id: 5,
    name: "iLove Event Space",
    spaces: "02",
    location: "United State",
    size: "1250 sqft",
  },
  {
    id: 6,
    name: "Spacious Multipurpose Event Space",
    spaces: "02",
    location: "United State",
    size: "1250 sqft",
  },
  {
    id: 6,
    name: "Trendy, Spacious Lounge in Alexandria",
    spaces: "03",
    location: "United State",
    size: "1250 sqft",
  },
  {
    id: 7,
    name: "Downtown Studio in the Heart of DC",
    spaces: "03",
    location: "France",
    size: "1250 sqft",
  },
  {
    id: 8,
    name: "Lounge with stage on Hst dc",
    spaces: "01",
    location: "France",
    size: "1250 sqft",
  },
  {
    id: 9,
    name: "Exquisite SkyLounge in Silver Spring",
    spaces: "01",
    location: "France",
    size: "1250 sqft",
  },
  {
    id: 10,
    name: "Friends Meeting of Washington",
    spaces: "02",
    location: "France",
    size: "1250 sqft",
  },
  {
    id: 11,
    name: "Spacious Lounge Space",
    spaces: "03",
    location: "France",
    size: "1250 sqft",
  },
];

export const initVanueData = {
  id: "",
  type: "",
  name: "",
  email: "",
  phone: "",
  description: "",
  // totalSpaces: "",
  architectTags: [],
  area: "",
  address: "",
  lat: 0,
  lng: 0,
  status: "draft",
};

export const MAP_LIBRARIES: (
  | "places"
  | "marker"
  | "geometry"
  | "drawing"
  | "visualization"
)[] = ["places", "marker"];

export const architectTypes = [
  "Art Deco",
  "Bauhaus",
  "Brutalist",
  "Colonial",
  "Contemporary",
  "Gothic",
  "Japanese / Zen",
  "Mediterranean",
  "Mid-Century",
  "Modern",
  "Neoclassical",
  "Scandinavian",
  "Tropical / Open-Air",
  "Victorian",
  "Warehouse / Industrial",
];
export const spaceTypes = [
  "Backyard",
  "Ballroom",
  "Barn",
  "Beachfront / Waterfront",
  "Church / Chapel",
  "Classroom",
  "Club / Lounge",
  "Conference Room",
  "Co-working Space",
  "Courtyard",
  "Exercise Space",
  "Gallery",
  "Garden / Greenhouse",
  "Hotel Event Space",
  "Loft",
  "Mansion",
  "Park / Outdoor",
  "Restaurant / Private Dining Room",
  "Rooftop",
  "School / Campus Venue",
  "Studio",
  "Theater",
  "Warehouse",
  "Winery / Brewery",
];

export const vibesTypes = [
  "Artistic / Eclectic",
  "Boho Chic",
  "Coastal / Beachy",
  "Cozy & Intimate",
  "Elegant",
  "Futuristic / Techy",
  "Glamorous",
  "Historic / Vintage",
  "Industrial",
  "Intimate",
  "Modern Minimalist",
  "Natural / Botanical",
  "Neutral / Blank Canvas",
  "Rustic / Farmhouse",
  "Urban Loft",
];

export const amenitiesTypes = [
  "AV Technician",
  "Bar Area",
  "Catering Options Available",
  "Catering Services",
  "Chairs",
  "Clothing Rack",
  "Coffee / Tea Station",
  "Conference Room",
  "Extension Cords",
  "Flip Chart",
  "Food Preparation Area",
  "Microphones",
  "Podium / Lectern",
  "Power Outlets",
  "Rest Lounge",
  "Security Staff",
  "Speakers",
  "Storage Space",
  "Tables",
  "Water Dispenser",
  "Whiteboard",
  "WiFi",
];

export const featuresTypes = [
  "Accept External Liquor License",
  "Air Conditioning",
  "Catering Services",
  "Changing Rooms",
  "Child Friendly",
  "Elevator Access",
  "Heating",
  "Kitchen",
  "Lighting Equipment",
  "Liquor License",
  "Load In/Out Capabilities",
  "Long Term Rental",
  "Natural Light",
  "Outdoor Area",
  "Parking Available",
  "Pet Friendly",
  "Projector",
  "Public Transportation Nearby",
  "Recurring Rental",
  "Restrooms",
  "Screen",
  "Soundproof",
  "Stage",
  "Wheelchair Accessible",
];

export const occassionTypes = [
  "Art Exhibition",
  "Baby Shower",
  "Bachelor(ette) Party",
  "Birthday Celebration",
  "Brand Activation",
  "Conference / Seminar",
  "Corporate Offsite",
  "Engagement Party",
  "Fashion Show",
  "Fundraiser / Gala",
  "Girls / Guys Night Out",
  "Graduation Party",
  "Holiday Party",
  "Networking Event",
  "Photoshoot / Filming",
  "Pop-Up Shop",
  "Private Dinner",
  "Product Launch",
  "Religious Ceremony",
  "Repass",
  "Retail Friendly",
  "Retreat / Wellness Event",
  "Retirement Party",
  "Seasonal",
  "Wedding",
  "Workshop / Training",
];

export const otherTypes = [
  "ADA Restrooms",
  "Arcade Games",
  "Cups Glasses",
  "Dance Floor",
  "Karaoke",
  "Lounge Lighting System",
  "Microphones",
  "Misc Activities",
  "Misc AV Equipment",
  "Nursing Rooms",
  "Prep Area",
  "Soft Seating",
  "Standard Restrooms",
  "Television",
];

export const customHours = [
  { label: "15 Mins", value: "15 minutes" },
  { label: "30 Mins", value: "30 minutes" },
  { label: "45 Mins", value: "45 minutes" },
  { label: "1 Hour", value: "1 hour" },
  { label: "2 Hours", value: "2 hours" },
  { label: "3 Hours", value: "3 hours" },
  { label: "4 Hours", value: "4 hours" },
  { label: "5 Hours", value: "5 hours" },
  { label: "6 Hours", value: "6 hours" },
  { label: "7 Hours", value: "7 hours" },
  { label: "8 Hours", value: "8 hours" },
  { label: "9 Hours", value: "9 hours" },
  { label: "10 Hours", value: "10 hours" },
  { label: "11 Hours", value: "11 hours" },
  { label: "12 Hours", value: "12 hours" },
  { label: "13 Hours", value: "13 hours" },
  { label: "14 Hours", value: "14 hours" },
  { label: "15 Hours", value: "15 hours" },
  { label: "16 Hours", value: "16 hours" },
  { label: "17 Hours", value: "17 hours" },
  { label: "18 Hours", value: "18 hours" },
  { label: "19 Hours", value: "19 hours" },
  { label: "20 Hours", value: "20 hours" },
  { label: "21 Hours", value: "21 hours" },
  { label: "22 Hours", value: "22 hours" },
  { label: "23 Hours", value: "23 hours" },
  { label: "24 Hours", value: "24 hours" },
];

export const customDays = [
  { label: "1 Day", value: "1 day" },
  { label: "2 Days", value: "2 days" },
  { label: "3 Days", value: "3 days" },
  { label: "4 Days", value: "4 days" },
  { label: "5 Days", value: "5 days" },
  { label: "6 Days", value: "6 days" },
  { label: "7 Days", value: "7 days" },
  { label: "8 Days", value: "8 days" },
  { label: "9 Days", value: "9 days" },
  { label: "10 Days", value: "10 days" },
  { label: "11 Days", value: "11 days" },
  { label: "12 Days", value: "12 days" },
  { label: "13 Days", value: "13 days" },
  { label: "14 Days", value: "14 days" },
  { label: "15 Days", value: "15 days" },
  { label: "16 Days", value: "16 days" },
  { label: "17 Days", value: "17 days" },
  { label: "18 Days", value: "18 days" },
  { label: "19 Days", value: "19 days" },
  { label: "20 Days", value: "20 days" },
  { label: "21 Days", value: "21 days" },
  { label: "22 Days", value: "22 days" },
  { label: "23 Days", value: "23 days" },
  { label: "24 Days", value: "24 days" },
  { label: "25 Days", value: "25 days" },
  { label: "26 Days", value: "26 days" },
  { label: "27 Days", value: "27 days" },
  { label: "28 Days", value: "28 days" },
  { label: "29 Days", value: "29 days" },
  { label: "30 Days", value: "30 days" },
];
